import Vue from 'vue';
import axios from '@/helpers/Axios'
import Vuex from 'vuex';
import { DateTime } from 'luxon'
import jwt_decode from "jwt-decode";

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    apiUrl: process.env.VUE_APP_API,
    user: null,
    userName: null,
    refreshTask: null // points to the setTimeout function
  },
  getters: {
    APIURL: state => {
        return state.apiUrl;
    },
    USER: state => {
        // Check to see if we have it in localStorage and set it if we do
        var storedUser = localStorage.getItem('user');
        if (storedUser != null) {
            state.user = JSON.parse(storedUser);
        }
        else {
            state.user = null;
        }
        return state.user;
    }
  },
  mutations: {
    clearUser(state) {
        state.user = null;
        state.userName = null;
        localStorage.removeItem('user');
    },
    setUser(state, user) {
        state.user = user;
        // Also set for localStorage
        localStorage.setItem('user', JSON.stringify(user));
    },
    setUserName(state, userName) {
        state.userName = userName;
    },
    refreshTokenTask(state, task) {
        state.refreshTask = task;
    },
    clearRefresh(state) {
        clearTimeout(state.refreshTask);
        state.refreshTask = null;
    },
    refreshUser(state) {
      var storedUser = localStorage.getItem('user');
      if (storedUser != null) {
          state.user = JSON.parse(storedUser);
      }
      else {
          state.user = null;
      }
      return state.user;
    }
  },
    actions: {
        refreshToken () {
          this.dispatch('refreshUser')
         // console.log("Reshreshing: token:", this.getters.USER.access_token, "refresh token:", this.getters.USER.refresh_token)
            axios.post('/Auth/Refresh', {
                token: this.getters.USER.access_token,
                refreshToken: this.getters.USER.refresh_token
            }, {timeout: 1000 * 20}).then((response) => {
                if (response.status == 200) {
                    var jwt = response.data;
                    this.commit('setUser', {
                        access_token: jwt.access_token,
                        expires_in: jwt.expires_in,
                        refresh_token: jwt.refresh_token
                    });
                    var decoded = jwt_decode(jwt.access_token);
                    this.commit('setUserName', decoded.given_name);

                    this.dispatch('autoRefresh')
                }
                else {
                    console.log('Got 401 Unauthorized from refresh token, clearing user');
                    this.commit('clearUser');
                }
            });
        },
        autoRefresh () {

            var tokenExpiryDate = DateTime.fromISO(this.getters.USER.expires_in);
            var msToNextCheck = (tokenExpiryDate.ts - (4 * 60000)) - DateTime.utc().ts; // check for refresh 5 minutes before token expires - changed to 4 to make sure its refreshed in time
            const refreshTask = setTimeout(() => this.dispatch('refreshToken'), msToNextCheck);
            //setInterval(() => console.log("token state: token:", this.getters.USER.access_token, "refresh token:", this.getters.USER.refresh_token), 1000);
            this.commit('refreshTokenTask', refreshTask);
        },
        clearRefresh() {
            this.commit('clearRefresh');
        },
        clearUser() {
            this.commit('clearUser');
        },
        refreshUser() {
          this.commit('refreshUser');
        },
        init() {
            console.log("Auth - loading data")
            var storedUser = localStorage.getItem('user');
            if (storedUser != null) {
              storedUser = JSON.parse(storedUser);

              var tokenExpiryDate = DateTime.fromISO(storedUser.expires_in).ts;
              if (tokenExpiryDate < DateTime.utc().ts) {
                  this.commit('clearUser');
                  this.commit('clearRefresh');
              }
              else {
                  this.commit('setUser', {
                      access_token: storedUser.access_token,
                      expires_in: storedUser.expires_in,
                      refresh_token: storedUser.refresh_token
                  });
                  var decoded = jwt_decode(storedUser.access_token);
                  this.commit('setUserName', decoded.given_name);
                  this.dispatch('autoRefresh')
              }
            } else {
              console.log("Auth - no stored user")
            }
        }
    }
})

store.dispatch('init');

export default store
